import isEmpty from 'lodash/isEmpty';

import { RESULT_MAPPING_KEY } from '../constants';

export const getResultPageId = (campaignId: string, firstResultPage: string) => {
    const ST = window.sessionStorage;
    let resultCounts: { [resultPageId: string]: number } = {};

    try {
        resultCounts = JSON.parse(ST.getItem(`${RESULT_MAPPING_KEY}${campaignId}`) || '');
    } catch (error) {
        console.error(
            `Failed to parse JSON from Session Storage key ${RESULT_MAPPING_KEY}${campaignId}:`,
            error,
        );
    }

    // if no result counts are found, return firstResultPage
    if (!resultCounts || isEmpty(resultCounts)) {
        return firstResultPage || null;
    }

    // if all result counts are equal (e.g. 0) return firstResultPage
    const counts = Object.values(resultCounts);
    const allValuesAreEqual = counts.every((val, i, arr) => val === arr[0]);

    if (allValuesAreEqual && firstResultPage) return firstResultPage;

    // Get result page with the highest count
    const highestCount = Object.keys(resultCounts).reduce((a, b) =>
        resultCounts[a] > resultCounts[b] ? a : b,
    );

    if (!highestCount) return firstResultPage;

    return highestCount;
};
